import React from 'react';
import { Message } from 'semantic-ui-react';

type ErrorMessagesProps = {
  onClearError: () => void;
  validationErrors: string[];
};

const ErrorMessages: React.FC<ErrorMessagesProps> = ({ onClearError, validationErrors }) => {
  return (
    <Message error onDismiss={onClearError}>
      <Message.Header>Error:</Message.Header>
      <Message.List>
        {validationErrors.map((error) => (
          <Message.Item key={error}>{error}</Message.Item>
        ))}
      </Message.List>
    </Message>
  );
};

export default ErrorMessages;
